import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Subject, map, of, switchMap } from 'rxjs';

import { SpinnerService } from '../spinner/spinner.service';

declare global {
  interface Window {
    prerenderReady: boolean;
  }
}

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class PrerenderService {
  public isPrerenderBot = false;

  private window = inject(DOCUMENT).defaultView;
  private platformId = inject(PLATFORM_ID);
  private ready: Subject<boolean> = new Subject<boolean>();

  private spinnerService = inject(SpinnerService);

  // subscribe to the ready flag, and when it's true, swap to the spinner visibility
  // and set prerenderReady to true after the spinner is hidden, then unsubscribe
  private subscription = this.ready
    .pipe(
      switchMap((ready) =>
        ready
          ? this.spinnerService.spinnerVisible$.pipe(map((visible) => !visible))
          : of(ready)
      )
    )
    .subscribe((ready) => {
      if (ready && isPlatformBrowser(this.platformId)) {
        window.prerenderReady = true;
        this.subscription.unsubscribe();
      }
    });

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.isPrerenderBot =
        this.window?.navigator.userAgent.includes('Prerender') || false;
    }
  }

  public setReady(ready: boolean): void {
    this.ready.next(ready);
  }
}
